export default "__VITE_ASSET__CiwydPMz__"